import { InjectionToken } from '@angular/core';

export interface ApiUrlConfig {
  baseUrl: string;
}

export const API_URL = new InjectionToken<ApiUrlConfig>('ApiUrlConfig');
